import { render } from "./TheSideMenu.vue?vue&type=template&id=1e8c992f&ts=true"
import script from "./TheSideMenu.vue?vue&type=script&lang=ts"
export * from "./TheSideMenu.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\repo\\ono\\ops-front-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__